// shared/src/commonMain/kotlin/com/tovtalk/data/remote/dto/V2Response.kt
package com.tovtalk.data.remote.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class V2Response<T>(
    val data: T? = null,
    val meta: V2Meta? = null,
    val errors: List<V2Error>? = null
)

@Serializable
data class V2Meta(
    @SerialName("cache_ttl") val cacheTtl: Int = 0,
    val version: String = "v2"
)

@Serializable
data class V2Error(
    val code: String? = null,
    val message: String,
    val details: JsonElement? = null
)

@Serializable
data class V2PaginatedData<T>(
    val items: List<T> = emptyList(),
    @SerialName("next_cursor") val nextCursor: String? = null,
    @SerialName("has_more") val hasMore: Boolean = false,
    @SerialName("kashrut_restricted") val kashrutRestricted: Boolean? = null
)
